import qs from 'qs'
import To from 'await-to-js'
import Callback from '@/services/Callback'
import { wizStandardInstance } from './instance'

export default class EntityTypeService {
  // 获取实体类型列表
  static async getEntityTypeList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassTypeAttributeCate?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 新增实体类型
  static async addEntityType(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassTypeAttributeCate', payload)
    )
    return Callback(err, res)
  }
  // 编辑实体类型
  static async updateEntityType(id, payload) {
    const [err, res] = await To(
      wizStandardInstance.put(`/api/std/StdClassTypeAttributeCate/${id}`, payload)
    )
    return Callback(err, res)
  }
  // 批量删除实体类型
  static async deleteEntityType(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/StdClassTypeAttributeCate/many', { data: payload })
    )
    return Callback(err, res)
  }
  // 获取实体类型属性列表
  static async getEntityTypeAttributeList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassTypeAttributeItem?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 新增实体类型属性
  static async addEntityTypeAttribute(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassTypeAttributeItem', payload)
    )
    return Callback(err, res)
  }
  // 编辑实体类型属性
  static async updateEntityTypeAttribute(id, payload) {
    const [err, res] = await To(
      wizStandardInstance.put(`/api/std/StdClassTypeAttributeItem/${id}`, payload)
    )
    return Callback(err, res)
  }
  // 获取实体类型属性详情
  static async getEntityTypeAttribute(id) {
    const [err, res] = await To(wizStandardInstance.get(`/api/std/StdClassTypeAttributeItem/${id}`))
    return Callback(err, res)
  }
  // 批量删除实体类型属性
  static async deleteEntityTypeAttribute(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/StdClassTypeAttributeItem/many', { data: payload })
    )
    return Callback(err, res)
  }
  // 批量导入实体类型
  static async importEntityType(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassTypeAttributeCate/excel-import', payload, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  // 导出实体类型
  static async exportEntityType(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassTypeAttributeCate/excel-export', payload, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  // 导入模板
  static async getEntityTypeTemplate() {
    const [err, res] = await To(
      wizStandardInstance.get('/api/std/StdClassTypeAttributeCate/excel-template', {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  // 批量发布
  static async publishList(type, payload) {
    const [err, res] = await To(
      wizStandardInstance.post(
        `/api/std/StdClassTypeAttributeCate/publish?publishType=${type}`,
        payload
      )
    )
    return Callback(err, res)
  }
}
